import moment from "moment";
import React, { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import "./ReUsableSingleRoundTab.css";

const ReUseableSingleRoundTab = ({ auditionRound, setActiveRound }) => {
  // const event_start = new Date(
  //   moment(auditionRound.round_start_date).format("LL") + " " + "00:00:00"
  // ).getTime();

  // const event_end = new Date(
  //   moment(auditionRound.round_end_date).format("LL") + " " + "00:00:00"
  // ).getTime();

  // const [day, setDay] = useState("");
  // const [hour, setHour] = useState("");
  // const [minute, setMinute] = useState("");
  // const [second, setSecond] = useState("");

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const now = new Date().getTime();
  //     const distance = event_start - now;

  //     const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //     setDay(days);
  //   });

  //   return () => clearInterval(interval);
  // }, [event_start]);

  return (
    <div className="col-md-3" onClick={() => setActiveRound(auditionRound.id)}>
      <div className="bg-dark mb-4 border-warning border rounded-lg ">
        <Nav.Item>
          <div className="px-5 py-2">
            <h3 className="text-warning text-center">Round</h3>
            <div className="text-warning  d-flex justify-content-center ">
              <h3 className="bgNum p-1 text-center fw-bolder">
                {auditionRound.round_num}
              </h3>
            </div>
          </div>
          <Nav.Link
            className="NavColorFan text-center fw-bold"
            eventKey={auditionRound.id}
          >
            Running
            {/* {auditionRound.id} */}
          </Nav.Link>
        </Nav.Item>
      </div>
    </div>
  );
};

export default ReUseableSingleRoundTab;
